module.exports = {
	"Search the video": "חפש בסרטון",
	"Explore": "נווט",
	"Print": "הדפס",
	"Download": "הורד",
	"Share": "שתף",
	"Settings": "הגדרות",
	"Language": "שפה",
	"Interface Language": "שפת ממשק",
	"Transcript / Captions Language": "שפת תמלול / כתוביות",
	"Transcript Language": "שפת תמלול",
	"Captions Language": "שפת כתוביות",
	"Show Transcript": "הצג תמלול",
	"Show Captions": "הצג כתוביות",
	"Show Heatmap": "הצג מפת חום",
	"Show Speakers in Transcript": "הצג את הדוברים בתמלול",
	"Keyword": "מילת מפתח",
	"Keywords": "מילות מפתח",
	"Topic": "נושא",
	"Topics": "נושאים",
	"Speaker": "דובר",
	"Speakers": "דוברים",
	"Transcript": "תמלול",
	"Previous": "קודם",
	"Next": "הבא",
	"Clear": "נקה חיפוש",
	"No results found": "אין תוצאות",
	"try another search or explore": "נסה חיפוש אחר או נווט",
	"Share Search": "שתף חיפוש",
	"Share Time": "שתף זמן",
	"There is no transcript available in the selected language.": "תמלול אינו זמין בשפה שנבחרה.",
	"Show {{count}} more": "הצג עוד {{count}}",
	"Show {{count}} more_plural": "הצג עוד {{count}}"
};


//////////////////
// WEBPACK FOOTER
// ./locale/he.json
// module id = ./locale/he.json
// module chunks = 0 1